import Info from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';
import SectionMessage from '@atlaskit/section-message';

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import t from 'modules/i18n/intl';

import { MACTableType } from './TableContent';
import { Dimensions } from '../../../components/visuals';
import config from '../../../appconfig';
import { messages } from '../messages';

const infoIcon = () => (
  <Info label="Info icon" color={token('color.icon.information', '#1D7AFC')} />
);

const InfoSectionMessage = styled.td`
  padding-top: ${Dimensions.units(3)}px;
`;

const partnerOrderNotFoundMessage = t(messages.partnerOrderNotFound, {
  ppcLink: (chunks) => (
    <a href={config.ppcUrl} target="_blank" rel="noopener noreferrer">
      {chunks}
    </a>
  ),
});

type Props = {
  tableType: MACTableType;
  isPartner?: boolean;
};

const NoItemsTableContent = ({ tableType, isPartner }: Props) => {
  return (
    <tr>
      {tableType === MACTableType.orders && (
        <InfoSectionMessage colSpan={5}>
          <SectionMessage appearance="information" icon={infoIcon} testId="no-quotes-banner">
            {isPartner ? (
              partnerOrderNotFoundMessage
            ) : (
              <FormattedMessage {...messages.ordersNoItems} />
            )}
          </SectionMessage>
        </InfoSectionMessage>
      )}
      {tableType === MACTableType.invoices && (
        <InfoSectionMessage colSpan={5}>
          <SectionMessage appearance="information" icon={infoIcon} testId="no-invoices-banner">
            {isPartner ? (
              partnerOrderNotFoundMessage
            ) : (
              <FormattedMessage {...messages.invoicesNotFound} />
            )}
          </SectionMessage>
        </InfoSectionMessage>
      )}
    </tr>
  );
};

export default NoItemsTableContent;
